import React, { useEffect, useState } from "react";
import { Button, message } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { getAllDamageStock, deleteDamageStock } from "../../../actions/Inventory/damageStockAction";
import DamageStockList from "./damageStockList";
import CreateDamageStock from "./CreateDamageStock";

const DamageStockIndex = () => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const loadData = async () => {
    setLoading(true);
    try {
      const data = await getAllDamageStock();
      setList(data);
    } catch {
      message.error("Failed to load damage stock list");
    }
    setLoading(false);
  };

  useEffect(() => {
    loadData();
  }, []);

  const handleDelete = async (id) => {
    try {
      await deleteDamageStock(id);
      message.success("Damage stock deleted");
      loadData();
    } catch {
      message.error("Failed to delete damage stock");
    }
  };

  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 10 }}>
        <h3>Damage Stock List</h3>
        <Button type="primary" icon={<PlusOutlined />} onClick={() => setDrawerOpen(true)}>
          Add Damage Stock
        </Button>
      </div>

      <DamageStockList list={list} loading={loading} onDelete={handleDelete} />
      <CreateDamageStock
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        reload={loadData}
      />
    </>
  );
};

export default DamageStockIndex;
